import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const K = {
  ink: "#004058",
  mid: "#4A6B7C",
  lt: "#94A3B8",
  sur: "#FFFFFF",
  bg: "#F8FAFC",
  brd: "#E2E8F0",
  alt: "#F1F5F9",
  red: "#EF4444",
  grn: "#10B981",
  mp: "#009EE3",
  r: { s: 6, m: 10, p: 14, l: 20, xl: 24, xxl: 32 },
  sh: { 
    s: "0 1px 4px rgba(0,0,0,.05)", 
    m: "0 4px 16px rgba(0,0,0,.08)", 
    l: "0 12px 40px rgba(0,0,0,.11)", 
    xl: "0 24px 72px rgba(0,0,0,.16)" 
  }
};

export default function SecurityPolicy() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: K.bg, fontFamily: "'Open Sans', sans-serif" }}>
      
      {/* Header Fixo */}
      <nav style={{
        background: "rgba(255,255,255,0.9)", backdropFilter: "blur(10px)", 
        borderBottom: `1px solid rgba(0,0,0,0.05)`, padding: "0 24px", height: 70, 
        display: "flex", alignItems: "center", justifyContent: "space-between", 
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 50
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
          <span 
            style={{ fontFamily: "'Poppins', sans-serif", fontSize: 24, fontWeight: 800, color: K.ink, cursor: "pointer" }} 
            onClick={() => navigate("/")}
          >
            Eventos<span style={{ color: "#009EE3" }}>&</span>Encontros
          </span>
        </div>
        <button 
          onClick={() => navigate("/")}
          style={{
            background: K.alt, color: K.ink, border: "none", padding: "8px 16px", 
            borderRadius: K.r.m, fontWeight: 700, cursor: "pointer", fontSize: 13
          }}
        >
          Voltar para Início
        </button>
      </nav>

      {/* Hero Section */}
      <header style={{
        background: `linear-gradient(135deg, ${K.ink} 0%, #001f2b 100%)`,
        padding: "140px 24px 80px",
        color: "#fff",
        textAlign: "center"
      }}>
        <div className="fu" style={{ maxWidth: 700, margin: "0 auto" }}>
          <div style={{
            display: "inline-block", background: "rgba(255,255,255,0.1)", 
            padding: "6px 14px", borderRadius: 100, fontSize: 13, 
            fontWeight: 600, marginBottom: 20, letterSpacing: 1
          }}>
            SEGURANÇA E CONFIABILIDADE
          </div>
          <h1 style={{ fontFamily: "'Poppins', sans-serif", fontSize: "clamp(32px, 5vw, 48px)", fontWeight: 800, marginBottom: 24, lineHeight: 1.2 }}>
            Política de Segurança
          </h1>
          <p style={{ fontSize: 18, opacity: 0.8, lineHeight: 1.6 }}>
            Seus dados e transações protegidos pelas tecnologias mais robustas do mercado.
          </p>
        </div>
      </header>

      {/* Conteúdo */}
      <main style={{ maxWidth: 800, margin: "-40px auto 100px", padding: "0 24px", position: "relative", zIndex: 10 }}>
        
        <div className="fu2" style={{
          background: K.sur, borderRadius: K.r.xl, boxShadow: K.sh.l, padding: "40px clamp(20px, 5vw, 50px)"
        }}>
          
          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 28 }}>🔒</span> Criptografia de Ponta a Ponta
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15, marginBottom: 12 }}>
              Toda a comunicação entre o seu navegador, o nosso aplicativo e nossos servidores é protegida pelo protocolo <strong>TLS/SSL (Transport Layer Security)</strong> de última geração. Isso garante que seus dados não possam ser interceptados ou lidos por terceiros durante a navegação.
            </p>
          </section>

          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 28 }}>💳</span> Segurança Financeira (PCI Compliance)
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15, marginBottom: 20 }}>
              Nós <strong>não armazenamos</strong> os dados do seu cartão de crédito. O Eventos e Encontros utiliza a infraestrutura de pagamentos do <strong>Mercado Pago</strong>, uma das maiores e mais seguras instituições financeiras da América Latina.
            </p>
            <ul style={{ color: K.mid, fontSize: 15, lineHeight: 1.8, paddingLeft: 20, marginBottom: 20 }}>
              <li><strong>Certificação PCI DSS:</strong> O Mercado Pago obedece aos rigorosos padrões de segurança da indústria de cartões de pagamento.</li>
              <li><strong>Anti-Fraude:</strong> Transações passam por inteligência artificial para detecção e bloqueio de fraudes em milissegundos.</li>
              <li><strong>Tokenização:</strong> Os dados sensíveis trafegam de forma criptografada.</li>
            </ul>
          </section>

          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 28 }}>☁️</span> Infraestrutura Google Cloud & Firebase
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15 }}>
              Todo o nosso banco de dados, gestão de ingressos e sistema de autenticação de usuários é gerido pela infraestrutura global de <strong>segurança militar do Google</strong> (Google Cloud Platform / Firebase). Seus dados pessoais estão resguardados por camadas de defesa, backups distribuídos e regras de acesso restritas, impedindo invasões e navegação lateral.
            </p>
          </section>

          <section>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 28 }}>✅</span> Ingressos Digitais Anti-Cambista
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15 }}>
              Nossos ingressos digitais possuem validadores únicos via <strong>QR Code assinado</strong>, atrelados ao seu CPF. Além de eliminar as filas de papel, nosso sistema impossibilita fraudes de falsificação na portaria, pois cada código é autenticado em tempo real nos nossos servidores e só pode ser validado uma única vez.
            </p>
          </section>

        </div>
      </main>

    </div>
  );
}
